import { getCurrentScrollPosition } from './utils';

export const checkToTopButtonPosition = (btnToTop: Element): void => {
  const scrollPos = getCurrentScrollPosition();
  const targetScrollPos = 500;

  if (scrollPos < targetScrollPos) {
    btnToTop.classList.remove('is-visible');
  } else {
    btnToTop.classList.add('is-visible');
  }
};
